<template>
  <section id="authnav" class="form column">
    <div>
      <b-navbar fixed-top>
        <template slot="brand">
          <b-navbar-item tag="router-link" :to="{ path: '/login' }">
            <img src="../../assets/images/virtualred-logo/gradiente/logo-red-gradiente-6x.png" alt="redonline" />
          </b-navbar-item>
        </template>
      </b-navbar>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
  name: "authnav"
};
</script>